<script setup>
    defineProps(['name'])
</script>

<template>
    <svg>
        <use :xlink:href="`#acc-${name}`"></use>
    </svg>
</template>